import { render, staticRenderFns } from "./cariDetay.vue?vue&type=template&id=6d4b8ee5&scoped=true&"
import script from "./cariDetay.vue?vue&type=script&lang=js&"
export * from "./cariDetay.vue?vue&type=script&lang=js&"
import style0 from "./cariDetay.vue?vue&type=style&index=0&id=6d4b8ee5&scoped=true&lang=css&"
import style1 from "./cariDetay.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./cariDetay.vue?vue&type=style&index=2&lang=css&"
import style3 from "./cariDetay.vue?vue&type=style&index=3&id=6d4b8ee5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4b8ee5",
  null
  
)

export default component.exports